
import React, { useEffect, useState } from 'react';

import DataGrid, {
    Column, Paging, Scrolling, Selection,
} from 'devextreme-react/data-grid';
import { TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';

export const ResultPopup = ({ initData, onDataChanged, onResultClick }) => {
    const [gridData, setGridData] = useState(initData);

    return (
        <DataGrid
            keyExpr={'resultId'}
            dataSource={gridData}
            height={350}
            hoverStateEnabled={true}
            rowAlternationEnabled={true}
            onRowClick={onResultClick}
        >
            <Column dataField="swimtime" caption="Schwimmzeit" cellRender={TimeBoxBold} />
            <Column dataField="date" caption="Datum" dataType='date' />
            <Column dataField="competitionName" caption="Wettkampfname" />
            <Column dataField="city" caption="Stadt" />
            <Column dataField="course" caption="Bahnlänge" />
            <Column dataField="split" caption="Zwischenzeit" />
            <Column dataField="qualification" caption="Qualifikationszeit" />

            <Paging
                enabled={false}
                defaultPageSize={10}
            />

            <Selection mode="single" />
        </DataGrid>
    );
};
